// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2UvwS","spin":"Spinner_spin__2E0OR"};